import React, { Component } from 'react';
import Head from '../../../../components/Head/Head';
import Auxiliary from '../../../../hoc/Auxiliary/Auxiliary';
import { withTranslation } from 'react-i18next';
import OutsourcingVsFullBanner from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingVsFull/OutsourcingVsFullBanner/OutsourcingVsFullBanner';
import OutsourcingVsFull2 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingVsFull/OutsourcingVsFull2/OutsourcingVsFull2';
import OutsourcingVsFull3 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingVsFull/OutsourcingVsFull3/OutsourcingVsFull3';
import OutsourcingVsFull4 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingVsFull/OutsourcingVsFull4/OutsourcingVsFull4';
import OutsourcingVsFull5 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingVsFull/OutsourcingVsFull5/OutsourcingVsFull5';
import OutsourcingVsFull6 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingVsFull/OutsourcingVsFull6/OutsourcingVsFull6';
import OutsourcingVsFull7 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingVsFull/OutsourcingVsFull7/OutsourcingVsFull7';
import OutsourcingVsFull8 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingVsFull/OutsourcingVsFull8/OutsourcingVsFull8';

class OutsourcingVsFull extends Component {
    render() {
        return (
            <Auxiliary>
                <Head id="outsourcing-vs-full" />
                <OutsourcingVsFullBanner {...this.props} />
                <OutsourcingVsFull2 {...this.props} />
                <OutsourcingVsFull3 {...this.props} />
                <OutsourcingVsFull4 {...this.props} />
                <OutsourcingVsFull5 {...this.props} />
                <OutsourcingVsFull6 {...this.props} />
                <OutsourcingVsFull7 {...this.props} />
                <OutsourcingVsFull8 {...this.props} />
                <div className='custom-end-outsourcing-vs-full'></div>
            </Auxiliary>
        );
    }
}

export default withTranslation()(OutsourcingVsFull);
